import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router'
import getRoutes from '../pages/routes'
import { ApolloProvider } from '@apollo/react-hooks'
import { useLocation } from 'react-use'

let routes = null

const Root = ({ store, history, client }) => {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash || hash.startsWith('#__')) {
      return
    }

    let timeouts = 10 // try 10 times only

    const scroll = () => {
      const id = hash.replace('#', '')
      const element = document.getElementById(id)

      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      } else {
        if (--timeouts) {
          setTimeout(scroll, 100) // no element yet, waiting
        }
      }
    }

    scroll()
  }, [pathname])

  // get routes only once
  if (!routes) {
    routes = getRoutes(store)
  }

  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <Router history={history} routes={routes} />
      </Provider>
    </ApolloProvider>
  )
}

export default Root



// WEBPACK FOOTER //
// ./src/app/Root.jsx